import {
    ILoadingIndicator,
    ILoadingIndicatorService,
    IShowLoadingIndicatorOptions, LOADING_INDICATOR_CONTAINER_ELEMENT_ID
} from "./loading-indicator.service.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {ServiceBase} from "../service-base";
import {IServiceFactory} from "../service-factory.interface";
import {ValidationError} from "../../types/errors/validation-error";


export class LoadingIndicatorService extends ServiceBase implements ILoadingIndicatorService {
    constructor(services: IServiceFactory) {
        super(services);
        makeObservable(this, {
            activeLoadingHandlers: observable
        });
    }

    activeLoadingHandlers: ILoadingIndicator[] = [];

    get current(): ILoadingIndicator | null {
        if(this.activeLoadingHandlers.length === 0) {
            return null;
        }

        return this.activeLoadingHandlers[this.activeLoadingHandlers.length - 1];
    }



    async execute<TResult = any>(options: IShowLoadingIndicatorOptions): Promise<TResult> {

        let loadingHandler: LoadingIndicatorHandler | null = null;
        loadingHandler = new LoadingIndicatorHandler(this, this.services, options.showPromotionalMessage || false);
        runInAction(() => {
            this.activeLoadingHandlers.push(loadingHandler!);
        });

        try {
            const result = await options.action();
            loadingHandler?.close();
            return result;
        }
        catch (err) {

            loadingHandler?.close();

            if(options.displayExceptionHandler) {
                options.displayExceptionHandler(err)
            } else {
                this._handleExceptionDisplay(err);
            }

            throw err;
        }
    }

    private _handleExceptionDisplay(exception: any): void {
        const genericErrorMsg = this.services.language.translate('There was an error processing your request');
        if(exception instanceof ValidationError) {
            this.services.alert.showError(exception.message);
        } else {
            this.services.logger.error('Async operation failed', exception);
            this.services.alert.showError(genericErrorMsg);
        }
    }
}

class LoadingIndicatorHandler implements ILoadingIndicator {
    constructor(private readonly loadingIndicatorService: LoadingIndicatorService,
                private readonly services: IServiceFactory,
                public readonly showPromotionalMessage: boolean) {
    }

    close() {
        const activeIndicatorHandlers = this.loadingIndicatorService.activeLoadingHandlers;
        const index = activeIndicatorHandlers.findIndex(h => h === this);
        if(index >= 0) {
            runInAction(() => {
                activeIndicatorHandlers.splice(index, 1);
                if(activeIndicatorHandlers.length === 0) {
                    // We do this here because if the executing action is very fast
                    // React cannot rerender that fast and the modal backdrop remains on screen forever and blocks the entire app
                    // So we make sure that the backdrop is removed from the dom when there are no more active loading indicators
                    setTimeout(() => {
                        const element = this.services.document.getElementById(LOADING_INDICATOR_CONTAINER_ELEMENT_ID);
                        if(element && activeIndicatorHandlers.length === 0) {
                            try {
                                element.remove();
                            } catch (err) {
                                this.services.logger.error('Failed to remove spinner from dom', err);
                            }
                        }
                    }, 50);
                }
            });
        }
    }
}
